import type { TSession } from "./activities"
import type { TCreated, TDBItem } from "./common"

export const categories = ["performance", "engagement", "culture", "wellbeing", "general"] as const
export const questionTypes = [
  "boolean",
  "date",
  "multiple",
  "number",
  "select",
  "string",
  "personal",
  "tags",
  "scale",
  "likert",
] as const

export type TQuestionType = (typeof questionTypes)[number]

export const evaluationQuestions: TSurveyQuestion["type"][] = ["scale", "likert"] as const

export const personalTypes = [
  "legal_name",
  "city",
  "birthday",
  "start_date",
  "size",
  "intro",
  "quote",
  "position",
  "manager",
  "phone",
  "email",
] as const

export type TPersonalType = (typeof personalTypes)[number]

export const scaleTypes = ["scale10", "scale5", "percent"] as const

export type TScaleType = (typeof scaleTypes)[number]

export const likertTypes = ["agree", "efficiency", "frequency", "satisfaction", "yes"] as const

export type TLikertType = (typeof likertTypes)[number]

export type TSurveyQuestion = {
  title: string
  order: number
  type: TQuestionType
  condition?: boolean
  category: (typeof categories)[number]
  note?: string
  is_required: boolean
  is_commentable: boolean
  meta: any
  activity_id: string
  ulid?: string
} & TDBItem &
  TCreated

export type TSurveyQuestionStats = {
  count: number
  percent?: number
} & TSurveyQuestion

export type TSurveyAnswer = {
  peer_id: string
  question_id: string
  user_id: string | null
  usersession_id: string | null
  value?: number | null
  comment?: string | null
} & TDBItem &
  TCreated

export type TSurveySessionStats = {
  session: TSession
  total_sessions: number
  completed_sessions: number
  questions: TSurveyQuestionStats[]
}

export type TSurveyUserSessionStats = {
  id: string // Fake ID
  count: number
  sum: number | null
  score: number | null
  usersession_id: string
}
